export const getRedirectUrl = (isEdition, postingId) => {
  const base = '/publicarPasoDatosPrincipales.bum';
  if (isEdition && postingId) {
    const params = new URLSearchParams({
      idaviso: postingId,
      checkContentEnhancerUrl: 'true',
      showOldReppro: 'true'
    });
    return `${base}?${params.toString()}`;
  }
  return base;
};
